import { render, staticRenderFns } from "./contactAffix.vue?vue&type=template&id=53058281&scoped=true"
import script from "./contactAffix.vue?vue&type=script&lang=js"
export * from "./contactAffix.vue?vue&type=script&lang=js"
import style0 from "./contactAffix.vue?vue&type=style&index=0&id=53058281&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53058281",
  null
  
)

export default component.exports